import ApiService from '../service/ApiService';
import ApiServiceFetch from '../service/ApiServiceFetch'

let moduleApi = {};
let moduleName = "survey_result";

moduleApi.create = (dataForm, params) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "Gửi thông tin khai báo không thành công"
    },
    params: params
  };
  return ApiService(api);
};

moduleApi.update = (dataForm, params) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "Gửi thông tin khai báo không thành công"
    },
    params: params
  };
  return ApiService(api);
};
moduleApi.getDataFromUrl = (url, method, headers, body) => {
  let objData = {
    method: method,
    url: url,
    headers: headers,
    body: body,
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceFetch(objData)

};


export default moduleApi;
